<template>
  <div class="fondocms">
    <div class="centered">
    <el-col> </el-col>
    <el-card class="box-card">
      <p class="admin">Iniciar Sesión</p>

      <el-form label-width="120px" class="login">
        <el-form-item class="email">
          <el-input
            type="email"
            v-model="email"
            placeholder="Correo electronico"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="password"
            v-model="password"
            placeholder="Contraseña"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="botonlog" @click="handleLogin"
            >Iniciar sesión
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    ...mapActions({
      login: "auth/login",
      validateSession: "auth/validateSession",
      // register : 'auth/register'
    }),
    async handleLogin() {
      let credentials = {
        email: this.email,
        password: this.password,
      };
      console.log("view", credentials);
      const res = await this.login(credentials);
      if (res.message) {
        this.$swal("Oops!", res.message, "error");
      }
    },
  },
  mounted() {
    this.validateSession();
  },
};
</script>

<style lang="scss" >
.centered {
  display: grid;
  place-items: center;
  padding: 2em;
}
.admin {
  font-family: "Avenir-bold";
  margin-top: 10px;
  font-size: 40px;
  color: #000d5a;
  font-weight: 200;
}
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
  width: 650px;
  margin-top: 5%;
}
.login .el-form-item__content {
  margin-left: 0 !important;
}
.login .el-form-item__label {
  color: #000d5a;
  text-align: start;
}
.login .el-input__inner {
  font-size: 20px;
  font-family: "Avenir";
  background-color: #fff !important;
  color: #000d5a !important;
  border: 1px solid #fff !important;
  border-radius: 20px !important;
  width: 80%;
  height: 52px !important;
  font-weight: 100;
}
.login .el-input__inner::placeholder {
  color: #000d5a !important;
  font-family: "Avenir";
  font-size: 20px;
}
.el-card.is-always-shadow {
  padding: 30px;
  padding-top: 50px;
  border-radius: 40px;
  box-shadow: 0px 4px 39px 3px rgba(0, 0, 0, 0.2);
  background-color: #f3f5f9 !important;
}
.botonlog {
  border-radius: 25px;
  height: 65px;
  width: 60%;
  font-size: 22px;
  font-family: "Avenir";
  color: #fff;
  background-color: rgba(0, 13, 90, $alpha: 0.5);
}
</style>